import React, { useContext, Fragment } from 'react'
import { Typography } from '@material-ui/core'
import moment from 'moment'
import DatePickerRange from '../../../../components/filters/DatePickerRange'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
import { defaultFormatTimeZone } from '../../../../utils/consts'

export default function DateRange (): JSX.Element {
  const { filters, setFilters } = useContext(CartChangeFiltersContext)
  const onChange = (initialDate: moment.Moment | null, finalDate: moment.Moment | null) => {
    setFilters({
      date: {
        initialDate,
        finalDate,
        ...defaultFormatTimeZone
      }
    })
  }

  return (
    <Fragment>
      <Typography id="discrete-slider-custom" gutterBottom>Período</Typography>
      <DatePickerRange
        defaultInitialValue={moment(filters.date?.initialDate)}
        defaultFinalValue={moment(filters.date?.finalDate)}
        onChange={onChange}
      />
    </Fragment>
  )
}
